import "../../sass/pages/siembra.scss";
import { getMultiTree, getTrees } from "../services/apis/siembra";
import Swal from "sweetalert2";

declare global {
    interface Window {
        dataLayer: any
    }
}

const map = document.getElementById("map")
const scrollMap = document.querySelector(".eternos__map")
const hand = document.getElementById("hand")

window.addEventListener("load", () => {
    onInit()
    if (window.screen.width < 850) scrollMap.scrollLeft = 650
    sendDatalayer()
})

const onInit = async () => {
    await getPoints()
    const points = [...document.getElementsByClassName("eternos__map__tree") as any] as HTMLElement[]
    const inputsContainer = [...document.getElementsByClassName("eternos__input") as any] as HTMLElement[]
    const broadcasts = [...document.getElementsByClassName("eternos__map__broadcast") as any] as HTMLElement[]


    points.forEach((item) => {
        if (item.children.length > 1) {
            item.children[1].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
            const button = item.children[0].children[0].children[1]
            button.addEventListener("click", () => closeDialog(item.children[0] as HTMLElement))
        } else {
            item.children[0].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
        }
    })
    map.parentElement.addEventListener("scroll", () => {
        hand.style.opacity = "0"
    })

    inputsContainer.forEach((item) => {
        const input = item.children[0] as HTMLInputElement
        const search = item.children[1] as HTMLElement
        search.addEventListener("click", () => onSearch(input.value))
    })
    broadcasts.forEach(item => {
        item.children[1].addEventListener("click", () => openDialog(item.children[0] as HTMLElement))
        const button = item.children[0].children[0].children[0]
        button.addEventListener("click", () => closeDialog(item.children[0] as HTMLElement))
    })


    const openDialog = (dialog: HTMLElement) => {
        if (dialog) {
            points.filter(item => item.classList.contains("fill") || item.classList.contains("me")).forEach(item => item.children[0].classList.remove("open"))
            dialog.classList.add("open")
        }
        return
    }
    const closeDialog = (dialog: HTMLElement) => {
        if (dialog) {
            dialog.classList.remove("open")
        }
        return
    }

    const onSearch = async (value: string) => {
        try {
            const format: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
            const data = await getMultiTree(value)
            if (data.length <= 0) {
                Swal.fire({ title: "SIN RESULTADOS", text: "No encontramos resultados para su busqueda", icon: "warning", confirmButtonColor: "#000000" })
                return
            }

            data.forEach(item => {
                const object = document.getElementById(`point(${item.x},${item.y})`)
                if (object) {
                    object.innerHTML =
                        `
                    <div class="eternos__tree__modal open">
                            <div class="eternos__modal__header multi">
                                <button class="eternos__modal__close">X</button>
                            </div>
                            <div class="eternos__modal__body multi">
                                ${item.users.map(user => `<p>${new Date(user.date).toLocaleDateString("ES-es", format)} - ${user.name} ${user.lastname}</p>`).join("")}
                            </div>
                    </div>
                    <img class="eternos__tree__image"
                        src="${map.getAttribute("data-treeFree")}"
                        alt="tree(${item.x},${item.y})">
                    `
                    object.children[1].addEventListener("click", () => openDialog(object.children[0] as HTMLElement))
                    const button = object.children[0].children[0].children[0]
                    button.addEventListener("click", () => closeDialog(object.children[0] as HTMLElement))
                }
            })
        } catch (error) {
            console.error(error);
        }
    }

}



const getPoints = async () => {
    try {
        const data = await getTrees();
        const format: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
        data.forEach(item => {
            map.innerHTML +=
                `
                <div id="point(${item.x},${item.y})" style="left: ${item.x}px;top: ${item.y}px;" class="eternos__map__tree ${(item.date && item.lastname && item.name) ? "fill" : ""}">
                ${(item.date && item.lastname && item.name) ? (`
                <div class="eternos__tree__modal">
                    <div class="eternos__modal__header">
                        <p>${item.name + " " + item.lastname}</p>
                        <button class="eternos__modal__close">X</button>
                    </div>
                    <div class="eternos__modal__body">
                        <img src="${map.getAttribute("data-treeFree")}"
                            alt="eternos__modal__image">
                        <p>Siembra digital: ${new Date(item.date).toLocaleDateString("ES-es", format)}</p>
                    </div>
                </div>
                `)
                    :
                    ""
                }
                <img class="eternos__tree__image"
                    src="${map.getAttribute("data-treeFree")}"
                    alt="tree(${item.x},${item.y})">
            </div>
            `
        })

    } catch (error) {
        console.error(error);

    }

}

const sendDatalayer = () => {

    const btn = document.querySelector('.eternos__info__title  a')
    btn.addEventListener("click", () => {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'GAEvent',
            event_category: 'Content',
            event_action: 'button',
            event_label: 'Súmate al legado',
            interaction: 'true',
            component_name: 'button_sumateallegado_mapa',
            element_text: 'Súmate al legado',
            campaign_description: 'Eternos'

        })
    })
}